module.exports = __webpack_public_path__ + "img/msg.7cc22e6a.png";